import classNames$1 from 'classnames';

var arrayHasValue = function arrayHasValue(value) {
  return Array.isArray(value) && !!value.length;
};
var hasActualValue = function hasActualValue(value) {
  return value === 0 || !!value;
}; // intentionally returns NaN for non numeric values

var convertValueToFloat = function convertValueToFloat(value) {
  return hasActualValue(value) ? parseFloat(value) : value;
};
var totalPercent = 100;
var convertPercentValueToDecimal = function convertPercentValueToDecimal(value) {
  return hasActualValue(value) ? parseFloat(value) / totalPercent : value;
};
var getChildHandler = function getChildHandler(handlerName, props, child) {
  var handler = props[handlerName];
  var childHandler = child.props[handlerName];
  return handler ? function () {
    childHandler.apply(void 0, arguments);
    handler.apply(void 0, arguments);
  } : childHandler;
};
var buildErrorText = function buildErrorText(_ref) {
  var _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      errorText = _ref.errorText,
      maxValidationErrors = _ref.maxValidationErrors,
      _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? ' ' : _ref$separator;
  var results = [].concat(errors);

  if (errorText) {
    results.unshift(errorText);
  }

  if (results && maxValidationErrors && maxValidationErrors > 0) {
    results = results.slice(0, maxValidationErrors);
  }

  return results.join(separator);
};
var getEventHandler = function getEventHandler(handlerName, props, child) {
  var handler = props[handlerName];
  var childHandler = child.props[handlerName];
  return handler ? function () {
    childHandler && childHandler.apply(void 0, arguments);
    handler && handler.apply(void 0, arguments);
  } : childHandler;
};
var constructFieldClassName = function constructFieldClassName(opts) {
  return classNames$1('form-control', constructPropertyDrivenFieldClassName(opts));
};
var constructPropertyDrivenFieldClassName = function constructPropertyDrivenFieldClassName(_ref2) {
  var className = _ref2.className,
      disabled = _ref2.disabled,
      large = _ref2.large,
      focused = _ref2.focused,
      readOnly = _ref2.readOnly;
  return classNames$1(className, {
    disabled: disabled,
    'input-lg': large,
    large: large,
    focus: focused,
    readonly: readOnly
  });
};

export { arrayHasValue, buildErrorText, constructFieldClassName, constructPropertyDrivenFieldClassName, convertPercentValueToDecimal, convertValueToFloat, getChildHandler, getEventHandler, hasActualValue };
